import React from 'react';

import GroupsDropdown from './GroupsDropdown';

class DefaultDropdown extends React.PureComponent {
  render() {
    return (
      <GroupsDropdown
        initialData={{ items: [] }}
        value={null}
        onChange={() => {}}
      />
    );
  }
}

export default DefaultDropdown;
